import React from 'react';
import { useFeatureFlag } from '../hooks/useFeatureFlag';

interface FeatureGateProps {
    /** Klíč feature flagu (MODUL_* / FEATURE_*). */
    flag: string;
    /** Co vykreslit při vypnutém flagu / během načítání (default nic — fail-closed). */
    fallback?: React.ReactNode;
    children: React.ReactNode;
}

/**
 * Deklarativní gate viditelnosti UI podle feature flagu (HO-88).
 * Fail-closed: během načítání i při chybě se renderuje fallback (UC-2/UC-3 z HO-84).
 * POZOR: pouze viditelnost (D1) — žádná bezpečnostní funkce, tu drží role na BE (D2).
 * Nepoužívat na veřejných stránkách (app-config je authenticated endpoint).
 */
const FeatureGate: React.FC<FeatureGateProps> = ({ flag, fallback = null, children }) => {
    const { enabled } = useFeatureFlag(flag);
    return <>{enabled ? children : fallback}</>;
};

export default FeatureGate;
